module.exports = __webpack_public_path__ + "static/media/instagram-red.ef91c719.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scss/icons/instagram-red.svg
// module id = 898
// module chunks = 0